'use strict';

/**
 * @description Codigo red de Mercado Component
 * @returns {Object} Devuelve la instancia del componente
 */

import { store } from '../../app.init.js';
import { servicesinterrupcion } from './interrupcion.services.js';
import { templateinterrupcion } from './interrupcion.template.js';
import i18n from 'i18next';

let componentinterrupcion = (function () {
  let context = {};
  let handlers = {};
  let renderSuccess = false;

  let preRenderComponent = () => {
    // Asi accedemos a la propiedad del store
    const state = store.getState();
    document.title = `${i18n.t('interruptibility_title')} | ${i18n.t(
      'page_subtitle'
    )}`;
    context.name = state.exampleReducer.name;
  };

  let renderComponent = async () => {
    const state = store.getState();
    try {
      // Render the template to the document
      let contactData = await servicesinterrupcion.init(
        state.exampleReducer.currentLang
      );

      // Define a template
      templateinterrupcion(context, handlers, contactData),
        (renderSuccess = true);
    } catch (error) {
      renderSuccess = false;
    }
  };

  let postRenderComponent = () => {
    const state = store.getState();
    context.name = state.exampleReducer.name;
  };

  let init = () => {
    //Call pre render component
    preRenderComponent();

    // Call render component
    renderComponent();

    // Call post render component if it has been rendered
    renderSuccess ? postRenderComponent() : '';
  };

  return {
    render: init,
  };
})();

export { componentinterrupcion };
